export const API_URL = process.env.REACT_APP_API_URL;

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";
export const POST_BULK_REGISTER = "/user/add-user-bulk";
export const CREATE_BULK_USER = "/user/add-bulk-users";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//PRODUCTS
export const ADD_PRODUCTS = "/product/add-one-Product";
export const EDIT_PRODUCTS = "/product/update-one-product";
export const GET_PRODUCTS = "/product/get-product-list";
export const GET_PRODUCTS_DETAIL = "/product/get-one-product";
export const DELETE_PRODUCT = "/product/delete-product";
export const DELETE_PRODUCT_IMAGE = "/product/delete-product-image"
//CART
export const GET_CART_ITEM = "/cart/get-cart";
export const ADD_TO_CART = "/cart/add-to-cart";
export const REMOVE_FROM_CART = "/cart/remove-from-cart";
export const GET_CART_LIST = "/cart/get-cart-list";
export const UPDATE_CART = "/cart/update-quantity";
export const EMPTY_CART = "/cart/remove-all-from-cart"

//WISHLIST
export const GET_WISHLIST_ITEM = "/wishlist/get-detail";
export const ADD_TO_WISHLIST = "/wishlist/add";
export const REMOVE_FROM_WISHLIST = "/wishlist/remove";
export const GET_WISHLIST_LIST = "/wishlist/get-list";

//Mails
export const GET_MAILS_LIST = "/mailslists";
export const SELECT_FOLDER = "/folders";
export const GET_SELECTED_MAILS = "/selectedmails";
export const SET_FOLDER_SELECTED_MAILS = "/setfolderonmail";
export const UPDATE_MAIL = "/update/mail";

//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/category/get-category-list";
export const GET_SUB_CATEGORIES = "/subCategory/get-sub-category-list";
//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDER_LIST = "/request-order/get-order-list";
export const ADD_NEW_ORDER = "/request-order/add-order";
export const UPDATE_ORDER = "/request-order/update-order";
export const GET_ONE_ORDER = "/request-order/get-one-order"
export const GET_ORDER_LOG = "/request-order/get-order-log"
export const GET_ORDER_STATUS = "/request-order/get-order-status"
export const GET_ORDER_STATUS_COUNT = "/request-order/get-order-status-count"
export const GET_ORDERS_STATUS_COUNT = "/order/get-order-status-count"
export const BULK_UPLOAD_EMPLOYEE = '/request-order/add-bulk-order-emp'
export const BULK_UPLOAD_ORDER_REQ = '/request-order/request-bulk-order-emp'
export const UPDATE_TRACKING_URL = '/order/update-tracking-url'
export const BULK_UPLOAD_ORDER_TARGET_REQ = '/request-order/request-bulk-upload-order-target-emp'

export const DELETE_ORDER = "/delete/order";
export const GET_ORDERS = "/orders";
export const BULK_UPLOAD = '/order/upload-bulk-orders'
export const BULK_UPLOAD_CART = '/order/upload-bulk-orders-cart'
export const GET_CONFIRM_ORDERS_LOG = "/order/get-order-log"
export const BULK_TARGET_UPLOAD = '/order/upload-bulk-target'

export const GET_CONFIRM_ORDER_LIST = "/order/get-order-list";
export const GET_ONE_CONFIRM_ORDER = "/order/get-one-order"
export const ADD_CONFIRM_NEW_ORDER = "/order/add-order";
export const UPDATE_CONFIRM_ORDER = "/order/update-order";
export const DELETE_CONFIRM_ORDER = "/order/delete-order";
export const GET_SHIPMENT_DETAILS = "/order/get-shipment-details";
export const DOWNLOAD_INVOICE = "/order/download-invoice";
export const GET_TRACKING_DETAILS = "/tracking-details/get";
export const GET_TRACKING_DETAILS_LIST = "/tracking-details/get-list";
export const ADD_OR_UPDATE_TRACKING_DETAILS = "/tracking-details//add-or-update";
//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";
export const GET_CRYPTO_PRODUCTS = "/crypto-products";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

// JOBS
export const GET_JOB_LIST = "/jobs";
export const ADD_NEW_JOB_LIST = "/add/job";
export const UPDATE_JOB_LIST = "/update/job";
export const DELETE_JOB_LIST = "/delete/job";

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply";
export const DELETE_APPLY_JOB = "add/applyjob";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//PROMOTION
export const GET_PROMOTION_LIST = "/promotion/get-promotion-list";
export const GET_PROMOTION = "/promotion/get-promotion";
export const ADD_NEW_PROMOTION = "/promotion/add-promotion";
export const UPDATE_PROMOTION = "/promotion/update-promotion";
export const DELETE_PROMOTION = "/promotion/delete-promotion";

//SALES OFFICE
export const GET_SALES_OFFICE_LIST = "/sales-office/get-sales-office-list";
export const GET_SALES_OFFICE_FILTER = "/sales-office/get-sales-office-filter";
export const GET_SALES_OFFICE = "/sales-office/get-sales-office";
export const ADD_NEW_SALES_OFFICE = "/sales-office/add-sales-office";
export const GET_SALES_OFFICE_OPTIONS = "/sales-office/get-sales-office-options";
export const UPDATE_SALES_OFFICE = "/sales-office/update-sales-office";
export const DELETE_SALES_OFFICE = "/sales-office/delete-sales-office";
export const GET_SALES_OFFICE_LIST_FOR_SELECT = "/sales-office/get-sales-office-list-for-select";
export const ADD_DEALER_SALES_OFFICE_MAPPING = "/dealer/create_dealer_salesOffice_mapping";


//TASKS
export const GET_TASKS = "/tasks";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//BLOG
export const GET_VISITOR_DATA = "/visitor-data";

//DASHBOARD CHARTS DATA
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

//DASHBOARD CRYPTO
export const GET_WALLET_DATA = "/wallet-balance-data";

//DASHBOARD JOBS
export const GET_STATISTICS_DATA = "/Statistics-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";

//ROLE
export const ADD_ROLE = "/roles/add-role";
export const GET_ROLE = "/roles/get-roles-list";
export const EDIT_ROLE = "/roles/update-role";
export const GET_ONE_ROLE = "/roles/get-role";
export const DELETE_ROLE = "/roles/delete-role";

//Permission
export const GET_ROLEPERMISSION = "/rolesPermissions/get-roles-permissions-list";
export const EDIT_ROLEPERMISSION = "/rolesPermissions/update-role-permissions";
export const GET_ROLEPERMISSION_LIST = "/rolesPermissionsV1/get-rolePermission-list"
export const EDIT_ROLEPERMISSION_LIST = "/rolesPermissionsV1/update-rolePermission"
export const GET_PERMISSION_FIELDS = "/rolesPermissionsV1/get-permission-list"
export const ADD_PERMISSION_LIST = "/rolesPermissionsV1/add-rolePermission"

// Role Data Access
export const GET_ROLE_DATA_ACCESS_LIST = "/role-data-access/get-role-data-access-list";
export const GET_ROLE_DATA_ACCESS_OPTIONS = "/role-data-access/get-options";
export const ADD_ROLE_DATA_ACCESS = "/role-data-access/add-role-data-access";
export const UPDATE_ROLE_DATA_ACCESS = "/role-data-access/update-role-data-access";
export const DELETE_ROLE_DATA_ACCESS_BY_ID = "/role-data-access/delete-role-data-access";
export const GET_ROLE_DATA_ACCESS_BY_ID = "/role-data-access/get-role-data-access";
export const CHECK_DATA_ACCESS = "/role-data-access/check-data-access";

//Address
export const GET_ADDRESS = "/address/get-address-list";
export const EDIT_ADDRESS = "/address/update-address";
export const ADD_ADDRESS = "/address/add-address";

//User
export const ADD_USER = "/api/user/add-user";
export const EDIT_USER = "/api/user/update-user";
export const Bulk_USER_FILE_UPLOAD = "/user/bulk-file-upload";
export const GET_FILE_BY_BATCH = "/user/get-file-upload-by-batch";
export const GET_FILE_COUNT = "/user/get-file-upload-count";
export const GET_ALL_FILE_DATA = '/user//get-data-by-batch'
export const GET_FILE_BY_FILEID = "/user/bulk-file-data-by-file-id"
export const GET_FILE_BY_ID = "/user/bulk-file-id"
export const GET_USER = "/api/user/get-user";
export const ADD_SAP_USER = "/user/employees/add";
export const GET_SAP_USER = "/user/employees/get-detail";
export const EDIT_SAP_USER = "/user/employees/update";
export const EDIT_USER_STATUS = "/user/employees/update-status";
export const GET_SAP_USER_LIST = "/user/employees/get-list";
export const GET_SAP_USER_OPTIONS = "/user/employees/get-options";
export const DELETE_SAP_USER = "/user/employees/delete";
export const GET_REPORTS_TO_LIST_FOR_SELECT = "/user/employees/get-reports-to-users";
export const GET_DEALER_USER_LIST = "/user/get-dealer-user";
export const ADD_DEALER_USER = "/user/add-dealer-user";
export const EDIT_DEALER_USER = "/user/update-dealer-user";
export const GET_ONE_DEALER_USER = "/user/get-one-dealer-user";


//Entity
export const GET_ENTITY = "/api/entity/get-entity-list";
export const EDIT_ENTITY = "/api/entity/update-entity";
export const ADD_ENTITY = "/api/entity/add-entity";

//Warehouse
export const GET_WAREHOUSE = "/api/warehouse/get-warehouse-master-list";
export const EDIT_WAREHOUSE = "/api/warehouse/update-warehouse";
export const ADD_WAREHOUSE = "/api/warehouse/add-warehouse";

//EntityMapping
export const GET_ENTITYMAP = "/api/entitymap/get-entitymapping-list";
export const EDIT_ENTITYMAP = "/api/entitymap/update-entitymapping";
export const ADD_ENTITYMAP = "/api/entitymap/add-entitymapping";
export const GET_ALLENTITY = "/api/entitymap/get-entity-list";

//Region
export const GET_DROP_DOWN_KEY_VALUES = "/dropdown/get-dropdown-key-values";

//PERMISSION
export const ADD_PERMISSION = "/permissions/add-permission";
export const GET_PERMISSION = "/permissions/get-permissions-list";
export const EDIT_PERMISSION = "/permissions/update-permission";
export const GET_ONE_PERMISSION = "/permissions/get-permission";
export const GET_MODULE_LIST = "/permissions/get-module-list";


//EMAIL TEMPLATE
export const ADD_TEMPLATE = "/templatesEmail/add-email-template";
export const GET_TEMPLATE = "/templatesEmail/get-template-master-email-list";
export const EDIT_TEMPLATE = "/templatesEmail/update-email-template";
export const GET_EMAIL_TEMPLATE = "/templatesEmail/get-template-email";

// SMS TEMPLATE
export const ADD_SMS_TEMPLATE = "/templatesSMS/add-sms-template";
export const GET_SMS_TEMPLATE_LIST = "/templatesSMS/get-template-master-sms-list";
export const EDIT_SMS_TEMPLATE = "/templatesSMS/update-sms-template";
export const GET_SMS_TEMPLATE = "/templatesSMS/get-template-sms";

// NOTIFICATION TEMPLATE
export const ADD_NOTIFICATION_TEMPLATE = "/templatesNotification/add-notification-template";
export const GET_NOTIFICATION_TEMPLATE_LIST = "/templatesNotification/get-template-master-notification-list";
export const EDIT_NOTIFICATION_TEMPLATE = "/templatesNotification/update-notification-template";
export const GET_NOTIFICATION_TEMPLATE = "/templatesNotification/get-template-notification";


//NOTIFICATION
export const GET_ALL_NOTIFICATION = "/notification/get-all-notifications";
export const GET_READ_NOTIFICATION = "/notification/get-read-notifications";
export const GET_UNREAD_NOTIFICATION = "/notification/get-unread-notifications";
export const UPDATE_MARK_READ = "/notification/update-markasread";
export const UPDATE_MARKALL_READ = "/notification/update-markallasread";

//API CONFIGURATION
export const ADD_API_CONFIGURATION = "/apiConfiguration/add-apiconfig";
export const GET_API_CONFIGURATION = "/apiConfiguration/get-apiconfig-list";
export const EDIT_API_CONFIGURATION = "/apiConfiguration/update-apiconfig";
export const GET_API_CONFIGURATION_BY_ID = "/apiConfiguration/get-apiconfig-by-id";

export const ADD_SYSTEM_CONFIGURATION = "/systemConfiguration/add-systemconfig";
export const GET_SYSTEM_CONFIGURATION = "/systemConfiguration/get-systemconfig-list";
export const EDIT_SYSTEM_CONFIGURATION = "/systemConfiguration/update-systemconfig";
export const GET_SYSTEM_CONFIGURATION_BY_ID = "/systemConfiguration/get-one-systemconfig";
export const GET_SYSTEM_CONFIGURATION_BY_KEY = "/systemConfiguration/get-one-systemconfig-by-name";
export const UPLOAD_FILE = "/s3/uploadSystemConfigFiles";
export const DOWNLOAD_FILE = "/s3/downloadSystemConfigFiles";

//Category
export const GET_CATEGORY_LIST = 'category/get-category-list';
export const ADD_CATEGORY_LIST = 'category/add-category';
export const GET_ONE_CATEGORY = 'category/get-one-category';
export const EDIT_CATEGORY_LIST = 'category/update-category';
export const DELETE_CATEGORY = "category/delete-category";
//SubCategory

export const ADD_SUB_CATEGORY = "/subCategory/add-sub-category";
export const GET_SUB_CATEGORY = "/subCategory/get-sub-category-list";
export const EDIT_SUB_CATEGORY = "/subCategory/update-sub-category";
export const GET_ONE_SUB_CATEGORY = "/subCategory/get-one-sub-category";
export const DELETE_SUB_CATEGORY = "/subCategory/delete-sub-category";

//Sign Inquiry

export const GET_SIGNUP_INQUIRY_LIST = "/signupInquiry/get-signup-inquiry-list";
export const ADD_SIGNUP_INQUIRY = "/signupInquiry/add-signup-inquiry";
export const EDIT_SIGNUP_INQUIRY = "/signupInquiry/update-signup-inquiry";
export const GET_ONE_SIGNUP_INQUIRY = "/signupInquiry/get-one-signup-inquiry";

export const UPLOAD_IMAGE = "/product/upload-image"

// DEALER
export const ADD_DEALER = "/dealer/add-dealer";
export const GET_DEALER = "/dealer/get-list";
export const EDIT_DEALER = "/dealer/update-dealer";
export const DELETE_DEALER = "/dealer/delete-dealer";
export const GET_ONE_DEALER = "/dealer/get-dealer";
export const GET_DEALER_OPTIONS = "/dealer/dealer-options";
export const UPDATE_DEALER_STATUS = "/dealer/update-dealer-status";
export const GET_SHIP_TO_PARTY_LIST = "/dealer/get-ship-to-party-list";

// INQUIRY
export const ADD_INQUIRY = "/productInquiry/add-product-inquiry";
export const ADD_BULK_PRODUCT = "/product/add-product";
export const GET_INQUIRY_LIST = "/productInquiry/get-product-inquiry-list";
export const GET_DEALER_INQUIRY_LIST = "/productInquiry/get-dealer-product-inquiry-list";
export const GET_INQUIRY_INFO = "/productInquiry/get-product-inquiry";
export const UPDATE_INQUIRY = "/productInquiry/update-product-inquiry";
export const UPLOAD_INQUIRY_FILE = "/productInquiry/upload-inquiry-file";
export const ADD_INQUIRY_REMARKS = "/productInquiry/add-remarks";
export const UPDATE_PRODUCT_INQUIRY_STATUS = "/productInquiry/update-product-inquiry-status";
export const GET_PRODUCT_INQUIRY_COUNT = "/productInquiry/get-product-inquiry-count";


export const ADD_NON_REGISTER_DEALER_INQUIRY = "/productInquiry/add-non-dealer-product-inquiry";
export const GET_NON_REGISTER_DEALER_INQUIRY = "/productInquiry/get-non-dealer-product-inquiry-list";
export const GET_ONE_NON_REGISTER_DEALER_INQUIRY = "/productInquiry/get-non-dealer-product-inquiry";
export const UPDATE_NON_DEALER_PRODUCT_INQUIRY_STATUS = "/productInquiry/update-non-dealer-product-inquiry-status";
export const ADD_NON_DEALER_INQUIRY_REMARKS = "/productInquiry/add-non-dealer-remarks";

// actual constants

//auth
export const LOGIN = '/auth/login';
export const LOGIN_URL = "/auth/login";
export const REFRESH_TOKEN_URL = "/auth/refresh-token"
export const RESET_PASSWORD = "/auth/reset-password"
export const FORGET_PASSWORD = "/auth/forgot-password"
export const SIGN_UP = "/entity/signUp"
export const VERIFY_LOGIN_OTP = "/auth/verify-otp"
export const VERIFY_OTP = "/auth/verify-otp"
export const RE_SEND_OTP = "/auth/resend-otp"
export const SEND_LOGIN_OTP = "/user/resend-otp"

export const GET_USERS_LIST = "/usersList";

//PLANT
export const GET_PLANTS_LIST = "/plant/get-plant-list";
export const GET_PLANT = "/plant/get-plant";
export const EDIT_PLANT = "/plant/update-plant";
export const DELETE_PLANT = "/plant/delete-plant";

//PAYMENT TERMS
export const GET_PAYMENT_TERMS_LIST = "/paymentterm/get-paymentterm-list";
export const GET_PAYMENT_TERMS = "/paymentterm/get-paymentterm";
export const EDIT_PAYMENT_TERMS = "/paymentterm/update-paymentterm";
export const DELETE_PAYMENT_TERMS = "/paymentterm/delete-paymentterm";

//STATE & CITY
export const GET_STATE_LIST = "/state/get-state-list";
export const GET_CITY_LIST = "/state/get-city-list";

//REPORT
export const GET_PRODUCT_REPORT = "/report/get-product-report";
export const GET_ORDER_REQUEST_REPORT = '/report/get-order-request-report';
export const GET_ORDER_REPORT = '/report/get-order-report';
export const GET_DEALER_REPORT = '/report/get-dealer-report';
export const GET_NEW_PRODUCT_REPORT = "/report/get-new-product-inquiry-report";
export const GET_SALE_PERFORMANCE_REPORT = "/report/get-sale-performance-report"

//MIS REPORT
export const GET_ZONE_WISE_SALES_REPORT = "/report/get-zone-wise-sales-report"
export const GET_PLANT_WISE_SALES_REPORT = "/report/get-plant-wise-sales-report"
export const GET_CUSTOMER_WISE_SALES_REPORT = "/report/get-customer-wise-sales-report"
export const GET_MTD_SALES_REPORT = "/report/get-mtd-sales-report"
export const GET_LEDGER_REPORT = "/report/get-ledger-report"
export const PENDING_ORDER_SALES_REPORT = "/report/get-pending-order-sales-report"
export const GET_TARGET_LIST = "/report/get-target-list"
export const GET_CREDIT_LIMIT = "/report/get-credit-limit"
export const GET_ALL_REGION = "/report/get-all-region"
export const GET_ACTUAL_SALE = "/report/get-acctual-sale"
export const GET_ACTUAL_SALE_VS_TARGET = "/report/get-acctual-sale-vs-target-report"
export const GET_MTD_SYNC = "/report/get-mtd-pending-report"
export const GET_ORDER_SYNC = "/report/get-pending-report"

//MODEL
export const GET_MODEL_LIST = "/model/get-model-list";

//DASHBOARD
export const GET_TOTAL_DEALER_COUNT = "/dashboard/get-total-dealer-count";
export const GET_TOTAL_INQUIRY_COUNT = "/dashboard/get-total-inquiry-count";
export const GET_TOTAL_ORDER_COUNT = "/dashboard/get-total-order-count";
export const GET_PENDING_ORDER_COUNT = "/dashboard/get-pending-order-count";
export const GET_REJECTED_ORDER_COUNT = "/dashboard/get-rejected-order-count";
export const GET_TOP_SELLING_PRODUCT = "/dashboard/get-top-selling-product";
export const GET_TOTAL_SALES = "/dashboard/get-total-sales";
export const GET_INDIVIDUAL_ORDER_STATUS_COUNT = "/dashboard/get-order-status-count";
export const GET_TOP_DEALER = "/dashboard/get-top-dealer";
export const GET_REGION_WISE_SALE = "/dashboard/get-region-wise-sales";
export const GET_PLANT_WISE_SALE = "/dashboard/get-plant-wise-sales";
export const GET_STORE_WISE_SALE = "/dashboard/get-store-wise-sales";
export const GET_TOTAL_PURCHASE = "/dashboard/get-total-purchase";
export const GET_TOTAL_PURCHASE_CREATED = "/dashboard/get-total-purchase-createdwise";

//MASTER
export const GET_MASTER = '/master/get-master'
export const GET_GENERAL_MASTER = '/general-master/get-general-master'

//REGION
//PROMOTION
export const GET_REGION_LIST = "/region/get-region-list";
export const GET_REGION = "/region/get-region";
export const ADD_NEW_REGION = "/region/add-region";
export const UPDATE_REGION = "/region/update-region";
export const DELETE_REGION = "/region/delete-region";

//API LOGS
export const GET_API_LOGS = "/api-logs/get";

//Query
export const GET_CUSTOMER_QUERY_LIST = "/query/get-customer-query-list";
export const ADD_QUERY = "/query/add-customer-query";
export const UPLOAD_QUERY_FILE = "/query/upload-query-file";
export const GET_QUERY_INFO = "/query/get-customer-query";
export const ADD_QUERY_REMARKS = "/query/add-remarks";
export const UPDATE_PRODUCT_QUERY_STATUS = "/query/update-customer-query-status";
